import { render, staticRenderFns } from "./wr_ytpsm_report.vue?vue&type=template&id=2a874d3a&scoped=true"
import script from "./wr_ytpsm_report.vue?vue&type=script&lang=js"
export * from "./wr_ytpsm_report.vue?vue&type=script&lang=js"
import style0 from "./wr_ytpsm_report.vue?vue&type=style&index=0&id=2a874d3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a874d3a",
  null
  
)

export default component.exports